import script from "./ScheduleManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./ScheduleManagement.vue?vue&type=script&setup=true&lang=js"

import "./ScheduleManagement.vue?vue&type=style&index=0&id=16488a74&scoped=true&lang=css"

import exportComponent from "/Users/lidonglei/Documents/project/Dean_DHSES/dean_dhses_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-16488a74"]])

export default __exports__